import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2033',
    ecrans: ['00-2'],
});
